import styled from "styled-components";

export const PrevMovieContainerRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
